let noticeElement
let hideTimer
let removeTimer

export function showNavigationEdgeNotice(message) {
  if (!message) return

  clearTimeout(hideTimer)
  clearTimeout(removeTimer)

  if (!noticeElement || !noticeElement.isConnected) {
    noticeElement = document.createElement('div')
    noticeElement.id = 'navigation-edge-notice'
    noticeElement.setAttribute('role', 'status')
    noticeElement.setAttribute('aria-live', 'polite')

    Object.assign(noticeElement.style, {
      position: 'fixed',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%) scale(0.96)',
      zIndex: '9999',
      padding: '0.5rem 1rem',
      borderRadius: '9999px',
      background: 'rgba(0, 0, 0, 0.72)',
      color: '#fff',
      fontSize: '0.875rem',
      fontWeight: '600',
      lineHeight: '1.25rem',
      boxShadow: '0 10px 25px rgba(0, 0, 0, 0.16)',
      pointerEvents: 'none',
      opacity: '0',
      transition: 'opacity 120ms ease-out, transform 120ms ease-out'
    })

    document.body.append(noticeElement)
  }

  noticeElement.textContent = message

  window.requestAnimationFrame(() => {
    if (!noticeElement) return

    noticeElement.style.opacity = '1'
    noticeElement.style.transform = 'translate(-50%, -50%) scale(1)'
  })

  hideTimer = setTimeout(() => {
    if (!noticeElement) return

    noticeElement.style.opacity = '0'
    noticeElement.style.transform = 'translate(-50%, -50%) scale(0.96)'
  }, 700)

  removeTimer = setTimeout(() => {
    noticeElement?.remove()
    noticeElement = null
  }, 900)
}
